import { createContext } from 'react';
import type { CustomThemeConfig } from './types';

export const ThemeContext = createContext<CustomThemeConfig | undefined>(undefined);
